import { ActionsCell } from '../../../Component/Common/Components/DataTable/ActionsCell';
import { DefaultCell } from '../../../Component/Common/Components/DataTable/DefaultCell';
import { ActionType, TableColumn } from '../../../Component/Model/Table/Table';
import { AutomatedNotificationRuleData, AutomatedNotificationRuleDataRow } from '../../../Component/Model/Dto/AutomatedNotification/AutomatedNotificationRule';
import { BaseTableRow } from '../../../Component/Common/Components/DataTable/BaseTableRow';

interface AutomatedNotificationRulesRow extends BaseTableRow{
  automatedNotificationType: string,
  message?: string,
  numberOfDaysToSendAfterScheduleDate: number,
  numberOfDaysToSendBeforeScheduleDate: number,
  Actions: ActionType[];
}

export interface AutomatedNotificationRuleTable {
  columns: Array<TableColumn>;
  rows: Array<AutomatedNotificationRulesRow>;
}

export function AutomatedNotificationRulesTableMapper(dataObject: AutomatedNotificationRuleData[], deleteNotification: (id: number) => void, editNotification: (id: number) => void): AutomatedNotificationRuleTable {
  const columns = [
    { Header: 'Notification Type', accessor: 'automatedNotificationType', Cell: ({ value }: any) => <DefaultCell  value={value} /> },
    { Header: 'Message', accessor: 'message', Cell: ({ value }: any) => <DefaultCell value={value} tooltip /> },
    { Header: 'Number of days after date', accessor: 'numberOfDaysToSendAfterScheduleDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
    { Header: 'Number of days before date', accessor: 'numberOfDaysToSendBeforeScheduleDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
    { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true, width: "20px"}
  ];
  if (dataObject && dataObject.length > 0) {
    const rows : AutomatedNotificationRulesRow[] = dataObject.map((item: AutomatedNotificationRuleData, index: number) => ({
      id: item.id,
      automatedNotificationType: item.automatedNotificationType,
      message: item.message,
      numberOfDaysToSendBeforeScheduleDate: item.numberOfDaysToSendBeforeScheduleDate,
      numberOfDaysToSendAfterScheduleDate: item.numberOfDaysToSendAfterScheduleDate,
      active : item.enabled,
      Actions: [
        {
          key: index.toString(),
          label: 'Edit',
          action: () => {
            editNotification(item.id);
          },
          icon: {
            color: 'info',
            name: 'edit'
          }
        },
        {
          key: index.toString(),
          label: 'Delete',
          action: () => {
            deleteNotification(item.id);
          },
          icon: {
            color: 'error',
            name: 'delete'
          }
        },
      ]

    }));
    return { columns: columns, rows: rows };
  }
  else {
    return { columns: columns, rows: [] };
  }
}

